import LayoutPadrao from 'lg-vue-components/layoutPadrao'
export default [
   {
      path: '/',
      redirect: 'nao-autorizado',
      component: LayoutPadrao,
      children: [
         {
            path: '/nao-autorizado',
            name: 'nao-autorizado',
            component: () => import('../pages/nao-autorizado.vue')
         }
      ]
   }
]
